import Vue from 'vue'
import "element-ui/lib/theme-chalk/index.css"
import { Button,Container,Header,Main,Footer,Breadcrumb,BreadcrumbItem,Icon,Input,Form,FormItem,Col,Table,TableColumn,Pagination } from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)